import { action, observable } from 'mobx';
import { clearBrandingVars } from '../utils/BrandingUtils';
import modernBrandingService from './modernBrandingService';

class ModernBrandingStore {
    @observable modernBranding = undefined;

    /** When set, default-brandings for this diId is already applied (avoids duplicate after AppLoader + Logout). */
    defaultBrandingLoadedForDiId = undefined;

    /** Tracks whether the active theme came from /brandings?type=legacy or /default-brandings?type=legacy. */
    brandingSource = undefined;

    /**
     * True only after default-brandings?type=legacy resolved with no theme (e.g. 204).
     * Avoids treating "still loading" the same as "empty default" in AppHelmet.
     */
    defaultBrandingUnavailable = false;

    async loadModernBranding(diId, isAuthenticated) {
        if (
            !isAuthenticated &&
            this.brandingSource === 'default' &&
            this.defaultBrandingLoadedForDiId === diId &&
            this.modernBranding
        ) {
            return this.modernBranding;
        }

        const modernBranding = await modernBrandingService.getModernBranding(
            diId,
            isAuthenticated,
        );

        if (!isAuthenticated && !modernBranding) {
            this.brandingSource = undefined;
            this.defaultBrandingLoadedForDiId = undefined;
            this.defaultBrandingUnavailable = true;
            this.setModernBranding(undefined);
            clearBrandingVars();

            // eslint-disable-next-line no-null/no-null
            return null;
        }

        this.setModernBranding(modernBranding);
        this.defaultBrandingUnavailable = false;

        if (isAuthenticated) {
            this.brandingSource = 'authenticated';
            this.defaultBrandingLoadedForDiId = undefined;
        } else if (modernBranding) {
            this.brandingSource = 'default';
            this.defaultBrandingLoadedForDiId = diId;
        }

        return modernBranding;
    }

    @action
    setModernBranding(modernBranding) {
        this.modernBranding = modernBranding;
    }
}

export default new ModernBrandingStore();
